export default __webpack_public_path__ + "static/pole-2-img-68ad069e1b6d7d27e6ef25ce7503ab7a.png";